import type { User } from "@supabase/supabase-js";

/**
 * `user.is_anonymous` may be `undefined` on Supabase /user responses for
 * permanent users, so `?? true` would mis-classify them as guests. Callers
 * should treat the field as anonymous only when it's explicitly `true`.
 */
export function isAnonymousUser(user: Pick<User, "is_anonymous"> | null | undefined): boolean {
  return user?.is_anonymous === true;
}
